import { generateRandomId } from '@/utils/uuid';
import { getCurrentTimestamp } from '@/utils/date';

export const generateMetainfo = () => {
    const id = generateRandomId();
    const timestamp = getCurrentTimestamp();

    return {
        id,
        timestamp,
    }
}
